import React, { Component } from 'react';
import AppConfig from '../../../utils/common/DomainConfiguration';
import { useLanguage } from '../../../utils/common/LanguageContext';
import Modal from 'react-modal';
import Loader from './Loader';
import { Link } from 'react-router-dom';
import { setIsPlaying } from '../../../utils/AthuService';

function RecordingModalWrapper(props) {
    const { t } = useLanguage();
    return <RecordingModal {...props} t={t} />;
}

class RecordingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            video: '',
            isPlaying: false,
        };
    }

    //handleVideoPlay
    handleVideoPlay = () => {
        setIsPlaying(true);
        this.setState({ isPlaying: true });
    };

    //handleVideoPause
    handleVideoPause = () => {
        setIsPlaying(false);
        this.setState({ isPlaying: false });
    };

    render() {
        let videoUrl = this.state.video ? this.state.video : this.props.videos[0];
        // Use domain config label if available, else fallback to translation key
        const recordingsLabel =
            AppConfig.labels && AppConfig.labels.recordings
                ? this.props.t(AppConfig.labels.recordings)
                : this.props.t('recordings');
        return (
            <Modal
                isOpen={this.props.isVideoOpen}
                onRequestClose={this.props.closeModal}
                className={'modal-recording-width'}
                overlayClassName={'modal-background z-index-1'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg bg-card">
                        <div className="flex items-start justify-between">
                            <h3 className="mt-0 text-lg font-medium text-white">
                                {recordingsLabel}
                            </h3>
                            <button type="button" onClick={this.props.closeModal}>
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        fill="white"
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        {this.state.isLoading ? (
                            <div className="mt-4">
                                <Loader />
                            </div>
                        ) : (
                            <>
                                <video
                                    className="w-full mt-2 video-player"
                                    controlsList="nodownload"
                                    disablePictureInPicture={true}
                                    controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}
                                    onPlay={this.handleVideoPlay}
                                    onPause={this.handleVideoPause}
                                >
                                    <source src={videoUrl} type="video/mp4" />
                                </video>
                                <div className="flex items-center justify-end gap-2 mt-4">
                                    <ul className="flex hand">
                                        {this.props.videos && this.props.videos.length > 1
                                            ? this.props.videos.map((res, index) => {
                                                  return (
                                                      <li
                                                          key={index}
                                                          className={`px-3 py-2 rounded-md border border-gray-600 text-white cursor-pointer transition ${
                                                              videoUrl === res
                                                                  ? 'bg-purple-600 text-white' // Active page styling
                                                                  : 'bg-transparent hover:bg-gray-700'
                                                          }`}
                                                          onClick={() => {
                                                              this.setState({ isLoading: true });
                                                              this.setState({ video: res }, () => {
                                                                  this.setState({
                                                                      isLoading: false,
                                                                  });
                                                              });
                                                          }}
                                                      >
                                                          <Link to="#" role="button">
                                                              {index + 1}
                                                          </Link>
                                                      </li>
                                                  );
                                              })
                                            : ''}
                                    </ul>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal>
        );
    }
}
export default RecordingModalWrapper;
